export const UNIVERSAL = 'UNIVERSAL';
export const CASH = 'CASH';
export const RETAILER = 'RETAILER';
export const TRANSACTIONAL = 'TRANSACTIONAL';
